import './assets/styles/App.css';
import LandingPage20 from './pages/LandingPage20';
import Cadastro from './pages/CadastroPage';
import Dashboard from './pages/DashboardPage';
import IncluirCredito from './pages/IncluirCreditoPage';
import CompanyRegister from './pages/CompanyRegisterPage';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./components/common/PrivateRoute";
import BotaoWhatsApp from './components/common/BotaoWhatsApp';
import { NotificacaoProvider } from "./context/NotificacaoContext";
import { AuthProvider } from './context/AuthContext';
import LeadIAPage from './pages/LeadIAPage';
import NutriaPage from './pages/NutrIAPage';
import AthenIAPage from './pages/AthenIAPage';

function App() {
  return (
     <NotificacaoProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={
              <>
                <LandingPage20 />
                <BotaoWhatsApp />
              </>} />
            <Route path="/cadastro" element={<Cadastro />} />
            <Route path="/company" element={<CompanyRegister />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/incluir-credito"
              element={
                <PrivateRoute>
                  <IncluirCredito />
                </PrivateRoute>
              }
            />
            <Route path="/products/leadia" element={ <LeadIAPage /> } />
            <Route path="/products/nutria" element={ <NutriaPage /> } />
            <Route path="/products/athenia" element={ <AthenIAPage /> } />
          </Routes>
          {/* <Footer /> */}
        </Router>
      </AuthProvider>
     </NotificacaoProvider>
  );
}

export default App;